import { AppRoutes } from 'containers/App/routes';

export const systemKeyParam = 'systemKey';
export const systemBaseRoute = `/system/${AppRoutes.SYSTEM_PARAM}`;
export const detailPageSuffix = '/edit';
